export const INSTAGRAM_URL = "https://www.instagram.com/ballooninginmoab"
export const INSTAGRAM_HANDLE = "@ballooninginmoab"
export const FACEBOOK_URL = "https://www.facebook.com/Moab-Balloon-Flights-106562834215779"

